import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";

import React, { useState, useEffect, useRef, useContext, useMemo } from "react";

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { Link } from "react-router-dom";
import UserDataTypeIntegration from "../../integrations/UserDataTypeIntegration";

import { EnvContext } from "../Context/EnvProvider";
import { useAuthToken } from "../../hooks/useAuthToken";
import useQuery from "../../hooks/useQuery";

const UserDataTypes = () => {
  const dataType = ["Texto", "Lista"];
  let emptyData = {
    dataName: "",
    dataType: "",
    useConfirmationFlag: true,
    modifyConfirmationFlag: true,
    sensitiveDataFlag: true,
  };
  const dt = useRef(null);
  const query = useQuery();
  const [userDataTypes, setUserDataTypes] = useState(emptyData);
  const [loading, setLoading] = useState(true);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [usersDataTypes, setUsersDataTypes] = useState([]);
  const [userDataTypesDialog, setUserDataTypesDialog] = useState(false);
  const [deleteUserDataTypesDialog, setDeleteUserDataTypesDialog] =
    useState(false);
  const [deleteUsersTypesDataDialog, setDeleteUsersDataTypesDialog] =
    useState(false);
  const [selectedUsersDataTypes, setSelectedUsersDataTypes] = useState(null);

  const toast = useRef(null);
  const userDataTypeIntegration = useMemo(() => new UserDataTypeIntegration(), []);
  const { getAccessToken } = useAuthToken();

  const { environment } = useContext(EnvContext);

  useEffect(() => {
    const templateId = query.get("templateId");
    const loadData = async () => {
      try {
        const authToken = await getAccessToken();
        const data = await userDataTypeIntegration.listUserDataTypes(environment.botApi, templateId, authToken);
        if (data.userDataTypes) {
          setUsersDataTypes(data.userDataTypes);
        } else {
          setUsersDataTypes([]);
        }
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
        toast.current?.show({
          severity: "error",
          summary: "Erro!",
          detail: "Erro ao carregar tipos de dados.",
          life: 5000,
        });
      }
    };

    loadData();
  }, [environment.botApi, query, userDataTypeIntegration, getAccessToken]);

  const openNew = () => {
    setUserDataTypes(emptyData);
    setUserDataTypesDialog(true);
  };

  const hideDialog = () => {
    setUserDataTypesDialog(false);
  };
  const hideDeleteUserDataTypesDialog = () => {
    setDeleteUserDataTypesDialog(false);
  };

  const hideDeleteUsersDataTypesDialog = () => {
    setDeleteUsersDataTypesDialog(false);
  };
  const confirmDeleteUserDataTypes = (userDataTypes) => {
    setUserDataTypes(userDataTypes);
    setDeleteUserDataTypesDialog(true);
  };
  const confirmDeleteSelected = () => {
    setDeleteUsersDataTypesDialog(true);
  };

  const deleteUserDataTypes = () => {
    let _usersDataTypes = usersDataTypes.filter(
      (val) => val.dataName !== userDataTypes.dataName
    );
    setUsersDataTypes(_usersDataTypes);
    setDeleteUserDataTypesDialog(false);
    setUserDataTypes(emptyData);
    toast.current.show({
      severity: "success",
      summary: "Sucesso!",
      detail: "Dado de usuário deletado!",
      life: 3000,
    });
  };
  const deleteSelectedUsersDataTypes = () => {
    let _usersDataTypes = usersDataTypes.filter(
      (val) => !selectedUsersDataTypes.includes(val)
    );
    setUsersDataTypes(_usersDataTypes);
    setDeleteUsersDataTypesDialog(false);
    setSelectedUsersDataTypes(null);
    toast.current.show({
      severity: "success",
      summary: "Sucesso!",
      detail: "Dados de usuários deletados!",
      life: 3000,
    });
  };
  const showResponseMessage = (json) => {
    if (json.success) {
      toast.current.show({
        severity: "success",
        summary: "Sucesso!",
        detail: "Tipos de dados de usuários salvo com sucesso! ",
        life: 5000,
      });
      setUserDataTypesDialog(false);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Erro!",
        detail: "Erro ao salvar os dados!",
        life: 5000,
      });
    }
  };
  const sendUserData = async () => {
    try {
      const authToken = await getAccessToken();
      const templateId = query.get("templateId");
      let templateUserDataTypes = { userDataTypes: [] };
      templateUserDataTypes.userDataTypes = [...usersDataTypes];
      const json = await userDataTypeIntegration.putUserDataTypes(
        environment.botApi,
        templateId,
        templateUserDataTypes,
        authToken
      );
      showResponseMessage(json);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Erro!",
        detail: "Erro ao enviar dados de usuário.",
        life: 5000,
      });
    }
  };

  const saveUserDataTypes = () => {
    let _usersDataTypes = [...usersDataTypes];
    let _userDataTypes = { ...userDataTypes };
    const index = findIndexById(userDataTypes.dataName); //datatype
    if (index >= 0) {
      _usersDataTypes[index] = _userDataTypes;
      toast.current.show({
        severity: "success",
        summary: "Sucesso!",
        detail: "Dado atualizado",
        life: 3000,
      });
    } else {
      _usersDataTypes.push(_userDataTypes);
      toast.current.show({
        severity: "success",
        summary: "Sucesso!",
        detail: "Dado criado",
        life: 3000,
      });
    }
    setUsersDataTypes(_usersDataTypes);
    setUserDataTypesDialog(false);
    setUserDataTypes(emptyData);
  };
  const findIndexById = (dataName) => {
    let index = -1;
    if (usersDataTypes.length) {
      for (let i = 0; i < usersDataTypes.length; i++) {
        if (usersDataTypes[i].dataName === dataName) {
          index = i;
          break;
        }
      }
      return index;
    } else return index;
  };
  const editUserDataTypes = (userDataTypes) => {
    setUserDataTypes({ ...userDataTypes });
    setUserDataTypesDialog(true);
  };

  const onInputChange = (e, name) => {
    let val;
    if (e.target.type === "checkbox") {
      val = e.target.checked;
    } else {
      val = (e.target && e.target.value) || "";
    }
    let _userDataTypes = { ...userDataTypes };
    _userDataTypes[`${name}`] = val;

    setUserDataTypes(_userDataTypes);
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Novo"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          onClick={openNew}
        />
        <Button
          label="Deletar"
          icon="pi pi-trash"
          className="p-button-danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedUsersDataTypes || !selectedUsersDataTypes.length}
        />
      </React.Fragment>
    );
  };
  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Salvar"
          icon="pi pi-save"
          className="p-button-success"
          onClick={sendUserData}
        />
      </React.Fragment>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editUserDataTypes(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={() => confirmDeleteUserDataTypes(rowData)}
        />
      </React.Fragment>
    );
  };
  const userDataTypesDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />

      <Button
        label="Salvar"
        icon="pi pi-check"
        className="p-button-text"
        type="submit"
        onClick={saveUserDataTypes}
      />
    </React.Fragment>
  );
  const deleteUserDataTypesDialogFooter = (
    <React.Fragment>
      <Button
        label="Não"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteUserDataTypesDialog}
      />
      <Button
        label="Sim"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteUserDataTypes}
      />
    </React.Fragment>
  );
  const deleteUsersDataTypesDialogFooter = (
    <React.Fragment>
      <Button
        label="Não"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeleteUsersDataTypesDialog}
      />
      <Button
        label="Sim"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deleteSelectedUsersDataTypes}
      />
    </React.Fragment>
  );
  const useBodyTemplate = (rowData) => {
    return rowData.modifyConfirmationFlag ? (
      <p style={{ margin: "0", lineHeight: "0" }}>Sim</p>
    ) : (
      <p style={{ margin: "0", lineHeight: "0" }}>Não</p>
    );
  };
  const alterationBodyTemplate = (rowData) => {
    return rowData.useConfirmationFlag ? (
      <p style={{ margin: "0", lineHeight: "0" }}>Sim</p>
    ) : (
      <p style={{ margin: "0", lineHeight: "0" }}>Não</p>
    );
  };
  const lgpdBodyTemplate = (rowData) => {
    return rowData.sensitiveDataFlag ? (
      <p style={{ margin: "0", lineHeight: "0" }}>Sim</p>
    ) : (
      <p style={{ margin: "0", lineHeight: "0" }}>Não</p>
    );
  };

  const header = (
    <div
      className="table-header"
      style={{
        justifyContent: "space-between",
        display: "flex",
        alignItems: "center",
      }}
    >
      <h5 className="p-m-0">Procurar Tipos de Dados</h5>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Procurar..."
        />
      </span>
    </div>
  );

  return (
    <div className="listBot">
      <Toast ref={toast} />
      <div className="card">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to="/ListBotTemplates">Lista de Templates</Link>
            </li>
            <li className="breadcrumb-item active">
              <span>Lista de Bot</span>
            </li>
          </ol>
        </nav>
      </div>

      <div className="card">
        <Toolbar
          className="p-mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>
        <DataTable
          ref={dt}
          value={usersDataTypes}
          loading={loading}
          selection={selectedUsersDataTypes}
          onSelectionChange={(e) => setSelectedUsersDataTypes(e.value)}
          emptyMessage="Nenhum dado encontrado!"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
            exportable={false}
          ></Column>
          <Column
            field="dataName"
            header="Nome do Dado"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            bodyStyle={{ textAlign: "center" }}
            field="dataType"
            header="Tipo de Dado"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            bodyStyle={{ textAlign: "center" }}
            field="useConfirmationFlag"
            header="Confirmação de Uso"
            body={useBodyTemplate}
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            bodyStyle={{ textAlign: "center" }}
            field="modifyConfirmationFlag"
            header="Confirmação de Alteração"
            body={alterationBodyTemplate}
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            bodyStyle={{ textAlign: "center" }}
            field="sensitiveDataFlag"
            body={lgpdBodyTemplate}
            header="Confidencial (LGPD)"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column body={actionBodyTemplate} style={{ width: "10rem" }}></Column>
        </DataTable>
      </div>
      <Dialog
        visible={userDataTypesDialog}
        style={{ width: "30vw" }}
        header="Dados de Usuário"
        modal
        baseZIndex={1300}
        className="p-fluid"
        footer={userDataTypesDialogFooter}
        onHide={hideDialog}
      >
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12">
            <label htmlFor="dataName">Nome do Dado</label>
            <InputText
              id="dataName"
              value={userDataTypes.dataName}
              onChange={(e) => onInputChange(e, "dataName")}
              required
            />
          </div>
          <div className="p-field p-col-12">
            <label htmlFor="type">Tipo do dado</label>
            <Dropdown
              value={userDataTypes.dataType}
              options={dataType}
              onChange={(e) => onInputChange(e, "dataType")}
            />
          </div>
          <div className="p-field p-col-12">
            <h5>Confirmação de Uso</h5>
            <div className="field-checkbox">
              <Checkbox
                inputId="binary"
                checked={userDataTypes.useConfirmationFlag}
                onChange={(e) => onInputChange(e, "useConfirmationFlag")}
              />
              <label style={{ marginLeft: "8px" }} htmlFor="binary">
                {userDataTypes.useConfirmationFlag ? "Sim" : "Não"}
              </label>
            </div>
          </div>
          <div className="p-field p-col-12">
            <h5>Confirmação de Alteração</h5>
            <div className="field-checkbox">
              <Checkbox
                inputId="binary"
                checked={userDataTypes.modifyConfirmationFlag}
                onChange={(e) => onInputChange(e, "modifyConfirmationFlag")}
              />
              <label htmlFor="binary" style={{ marginLeft: "8px" }}>
                {userDataTypes.modifyConfirmationFlag ? "Sim" : "Não"}
              </label>
            </div>
          </div>
          <div className="p-field p-col-12">
            <h5>Confidencial (LGPD)</h5>
            <div className="field-checkbox">
              <Checkbox
                inputId="binary"
                checked={userDataTypes.sensitiveDataFlag}
                onChange={(e) => onInputChange(e, "sensitiveDataFlag")}
              />
              <label htmlFor="binary" style={{ marginLeft: "8px" }}>
                {userDataTypes.sensitiveDataFlag ? "Sim" : "Não"}
              </label>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={deleteUserDataTypesDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deleteUserDataTypesDialogFooter}
        onHide={hideDeleteUserDataTypesDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {userDataTypes && (
            <span>
              Tem certeza de que deseja excluir <b>{userDataTypes.name}</b>?
            </span>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deleteUsersTypesDataDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deleteUsersDataTypesDialogFooter}
        onHide={hideDeleteUsersDataTypesDialog}
      >
        <div className="confirmation-content">
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {userDataTypes && (
            <span>
              Tem certeza de que deseja excluir os dados de usuários
              selecionados?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
};
export default UserDataTypes;
